import { ApiService } from "./ApiService"

export class EmployeePositionService {

    static uri = '/employee-position';

    static get() {
        return ApiService.get(`${this.uri}`);
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data);
    }
}